export const AI_PROMPT_TYPE = {
  DESCRIPTIVE: 'descriptive',
  FRIENDLY: 'friendly',
  IMPROVE_WRITING: 'improve_writing',
  PROFESSIONAL: 'professional',
  PROOFREAD: 'proofread',
  SHORTEN: 'shorten',
}

export interface AiConversationBody {
  childFirstName?: string
  message: string
  prompt: string
  uuid?: string
}
